var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import constants from "../config/constants";
import moment from 'moment';
export var pwdValidation = function (password, initial_pwdErrors, component) {
    var validatePwd = __assign({}, initial_pwdErrors);
    var _validatePwd;
    validatePwd.isValidLength = password.trim().length >= 10;
    validatePwd.doesHvUCase = constants.regex.atleastOneUCharRegExp.test(password);
    validatePwd.doesHvLCase = constants.regex.atleastOneLCharRegExp.test(password);
    validatePwd.doesHvNum = constants.regex.atleastOneNumRegExp.test(password);
    validatePwd.doesHvSplChar = constants.regex.atleastOneSplCharRegExp.test(password);
    if (component !== undefined && component === 'passwordStrength') {
        var isValidLength = validatePwd.isValidLength, restObj = __rest(validatePwd, ["isValidLength"]);
        _validatePwd = __assign({}, restObj);
    }
    var isValid = Object.values(_validatePwd || validatePwd).every(function (criteria) { return criteria === true; }) || !password;
    return (component !== undefined && component === 'resetPassword') ? _validatePwd || validatePwd : isValid;
};
export var formatPhoneNumber = function (phoneNumber) {
    var cleaned = ('' + phoneNumber).replace(/\D/g, '');
    var match = RegExp(/^(\d{3})(\d{3})(\d{4})$/).exec(cleaned);
    if (match) {
        return "(".concat(match[1], ") ").concat(match[2], "-").concat(match[3]);
    }
    return phoneNumber;
};
export var formatPhoneNumberDashed = function (phoneNumber) {
    if (!phoneNumber)
        return '';
    var digits = String(phoneNumber).replace(/\D/g, '');
    var national = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
    if (national.length === 10) {
        return "".concat(national.slice(0, 3), "-").concat(national.slice(3, 6), "-").concat(national.slice(6));
    }
    return String(phoneNumber);
};
export var formatTaxId = function (value, kind) {
    if (kind === void 0) { kind = 'ssn'; }
    if (!value)
        return '';
    var digits = String(value).replace(/\D/g, '');
    if (digits.length !== 9)
        return String(value);
    return kind === 'ein'
        ? "".concat(digits.slice(0, 2), "-").concat(digits.slice(2))
        : "".concat(digits.slice(0, 3), "-").concat(digits.slice(3, 5), "-").concat(digits.slice(5));
};
export var maskTaxId = function (value) {
    if (!value)
        return '';
    var text = String(value);
    var totalDigits = text.replace(/\D/g, '').length;
    if (totalDigits <= 4)
        return text.replace(/\d/g, '•');
    var seen = 0;
    return text.replace(/\d/g, function (digit) {
        seen += 1;
        return seen > totalDigits - 4 ? digit : '•';
    });
};
export var maskPhoneNumber = function (phoneNumber) {
    if (!phoneNumber)
        return "";
    var cleaned = ("" + phoneNumber).replace(/\D/g, "");
    if (cleaned.length < 4)
        return phoneNumber;
    return "\u2022\u2022\u2022\u2022 ".concat(cleaned.slice(-4));
};
export var getPhoneActionLabel = function (phoneNumber, isPhoneVerified) {
    if (!phoneNumber)
        return "Add Phone Number";
    return isPhoneVerified ? "Update Phone Number" : "Verify Number";
};
export var deepEqual = function (obj1, obj2) {
    if (obj1 === obj2) {
        return true;
    }
    if (typeof obj1 !== typeof obj2) {
        return false;
    }
    if (obj1 === null || obj2 === null) {
        return false;
    }
    if (typeof obj1 === 'object') {
        if (Array.isArray(obj1)) {
            if (!Array.isArray(obj2) || obj1.length !== obj2.length) {
                return false;
            }
            for (var i = 0; i < obj1.length; i++) {
                if (!deepEqual(obj1[i], obj2[i])) {
                    return false;
                }
            }
            return true;
        }
        else {
            var keys1 = Object.keys(obj1);
            var keys2 = Object.keys(obj2);
            if (keys1.length !== keys2.length) {
                return false;
            }
            for (var _i = 0, keys1_1 = keys1; _i < keys1_1.length; _i++) {
                var key = keys1_1[_i];
                if (!deepEqual(obj1[key], obj2[key])) {
                    return false;
                }
            }
            return true;
        }
    }
    return false;
};
export var AppTypes = [
    "Credit Application", "Line of Credit Application", "SCH-TakeDown Application"
];
export var getCommaSeparatedForAmounts = function (amount, decimalCount) {
    var _a;
    if (amount) {
        var formatAmount = amount;
        if (amount && typeof amount === 'string') {
            var value = amount === null || amount === void 0 ? void 0 : amount.replace(/[$,]/g, '');
            if (value) {
                formatAmount = Number(value);
            }
        }
        var roundedSum = parseFloat((_a = Number(formatAmount)) === null || _a === void 0 ? void 0 : _a.toFixed(decimalCount ? decimalCount : 2));
        if (roundedSum) {
            var hasDecimal = String(roundedSum).includes('.');
            if (hasDecimal) {
                var sumWithCommas = numberWithCommasForAmounts(roundedSum);
                if (String(sumWithCommas).split(".")[1].length < 2) {
                    sumWithCommas = sumWithCommas + '0';
                }
                return sumWithCommas;
            }
            else {
                return numberWithCommasForAmounts(roundedSum) + '.00';
            }
        }
    }
    return '';
};
export var numberWithCommasForAmounts = function (x) {
    return x ? "$".concat(x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")) : 0;
};
export var convertUTCToLocal = function (utcTimestamp) {
    return moment.utc(utcTimestamp).local().format('MM/DD/YYYY hh:mm A');
};
var numberWithCommasForPercentages = function (x) {
    return x.toLocaleString('en-US');
};
export var getCommaSeparatedForPercentages = function (amount, isDecimal) {
    if (amount === null || amount === undefined || amount === '') {
        return '';
    }
    var formatAmount;
    if (typeof amount === 'string') {
        var cleaned = amount.replace(/[%,$\s]/g, '');
        formatAmount = Number(cleaned);
    }
    else {
        formatAmount = amount;
    }
    if (isNaN(formatAmount)) {
        return '';
    }
    var percentValue = !isDecimal ? formatAmount * 100 : formatAmount;
    var formattedEight = percentValue.toLocaleString('en-US', {
        minimumFractionDigits: 8,
        maximumFractionDigits: 8,
    });
    var decimalPart = formattedEight.split('.')[1];
    if (decimalPart) {
        var afterTwoDecimals = decimalPart.slice(2);
        if (/^0+$/.test(afterTwoDecimals)) {
            return "".concat(percentValue.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }), "%");
        }
    }
    return "".concat(formattedEight, "%");
};
export var formatPercentageValue = function (value) {
    if (value === null || value === undefined || value === '') {
        return '';
    }
    var numericValue;
    if (typeof value === 'string') {
        numericValue = Number(value.replace(/[%,$\s]/g, ''));
    }
    else {
        numericValue = value;
    }
    if (isNaN(numericValue)) {
        return '';
    }
    var formattedEight = numericValue.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 8,
    });
    var _a = formattedEight.split('.'), intPart = _a[0], decimalPart = _a[1];
    if (decimalPart) {
        var trimmedDecimal = decimalPart.replace(/0+$/, '');
        if (trimmedDecimal.length <= 2) {
            return "".concat(numericValue.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }), "%");
        }
    }
    return "".concat(formattedEight, "%");
};
export var convertStringValuesToNumbers = function (x) {
    var formatedValue;
    if (x && typeof x == 'string') {
        var value = x === null || x === void 0 ? void 0 : x.replace(/[$,]/g, '');
        if (value) {
            formatedValue = Number(value);
        }
        return formatedValue;
    }
    else {
        return x;
    }
};
export var formatCurrency = function (amount) {
    if (amount === null || amount === undefined || amount === '') {
        return '$0.00';
    }
    var numAmount;
    if (typeof amount === 'string') {
        var cleaned = amount.replace(/[$,]/g, '');
        numAmount = parseFloat(cleaned);
    }
    else {
        numAmount = amount;
    }
    if (isNaN(numAmount)) {
        return '$0.00';
    }
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(numAmount);
};
export var isValidPortalName = function (portalName) {
    if (!portalName)
        return false;
    if (typeof portalName !== 'string')
        return false;
    var trimmed = portalName.trim();
    return trimmed.length > 0;
};
export var getCustomerPortalDisplayName = function (portalName) {
    if (!isValidPortalName(portalName))
        return '';
    var normalized = portalName.trim().toLowerCase();
    if (normalized.includes('auxcap') || normalized.includes('auxilior')) {
        return 'Auxilior';
    }
    if (normalized.includes('avant')) {
        return 'Avant';
    }
    return portalName || '';
};
export var sortCustomerPortals = function (portals) {
    var rank = function (name) {
        var display = getCustomerPortalDisplayName(name);
        return display === 'Auxilior' ? 0 : display === 'Avant' ? 1 : 2;
    };
    return __spreadArray([], portals, true).sort(function (a, b) { return rank(a.PortalName) - rank(b.PortalName); });
};
export var validateDate = function (date) {
    if (!date) {
        return { isValid: true, errorMessage: '' };
    }
    var currentYear = moment().year();
    if (moment.isMoment(date) || date instanceof Date) {
        var momentDate = moment(date);
        if (!momentDate.isValid()) {
            return { isValid: false, errorMessage: 'Invalid date format' };
        }
        var year_1 = momentDate.year();
        if (year_1 < 1850 || year_1 > currentYear + 100) {
            return {
                isValid: false,
                errorMessage: "Invalid year. Year must be between 1850 and ".concat(currentYear + 100),
            };
        }
        return { isValid: true, errorMessage: '' };
    }
    var dateStr = (date === null || date === void 0 ? void 0 : date.toString) ? date.toString().trim() : String(date).trim();
    if (!dateStr) {
        return { isValid: true, errorMessage: '' };
    }
    var datePattern = /^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})$/;
    var match = dateStr.match(datePattern);
    if (!match) {
        return { isValid: false, errorMessage: 'Invalid date format' };
    }
    var month = parseInt(match[1], 10);
    var day = parseInt(match[2], 10);
    var year = parseInt(match[3], 10);
    if (year < 1850 || year > currentYear + 100) {
        return {
            isValid: false,
            errorMessage: "Invalid year. Year must be between 1850 and ".concat(currentYear + 100),
        };
    }
    var strictDate = moment(dateStr, ['MM/DD/YYYY', 'M/D/YYYY', 'MM-D-YYYY', 'M-D-YYYY'], true);
    if (!strictDate.isValid() || strictDate.month() + 1 !== month || strictDate.date() !== day) {
        return { isValid: false, errorMessage: 'Invalid date - day does not exist in the selected month' };
    }
    return { isValid: true, errorMessage: '' };
};
export var NAME_MAX_LENGTH = 16;
export var NAME_SINGLE_SPACE_PATTERN = /^[A-Za-z0-9]+(?: [A-Za-z0-9]+)*$/;
export var validateNameField = function (value, fieldLabel) {
    if (!value || typeof value !== 'string') {
        return "Please Enter ".concat(fieldLabel);
    }
    var trimmed = value.trim();
    if (trimmed === '') {
        return "Please Enter ".concat(fieldLabel);
    }
    if (trimmed.length > NAME_MAX_LENGTH) {
        return "".concat(fieldLabel, " cannot exceed ").concat(NAME_MAX_LENGTH, " characters");
    }
    if (!NAME_SINGLE_SPACE_PATTERN.test(trimmed)) {
        return "".concat(fieldLabel, " can only contain letters, numbers, and single spaces between words");
    }
    if (/^\d+$/.test(trimmed)) {
        return "".concat(fieldLabel, " cannot be all numbers");
    }
    return '';
};
export var sanitizeNameFieldInput = function (value) {
    var cleaned = value.replace(/[^A-Za-z0-9 ]/g, '');
    var normalized = cleaned.replace(/ {2,}/g, ' ');
    var trimmedStart = normalized.replace(/^ +/, '');
    return trimmedStart.slice(0, NAME_MAX_LENGTH);
};
export var safeJsonParse = function (value, fallback) {
    if (fallback === void 0) { fallback = null; }
    if (value === null || value === undefined || value === '')
        return fallback;
    if (typeof value !== 'string')
        return value;
    try {
        return JSON.parse(value);
    }
    catch (error) {
        return fallback;
    }
};
export var downloadBlob = function (blob, filename) {
    var url = URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};
